var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDSignalCoolingPumpStaged2 = function SvgDSignalCoolingPumpStaged2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 462,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,452c5.51,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M18,451c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z",
    fill: "#1c9d5b"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "16.53 466.04 16.53 462.11 20.46 462.11 20.46 458.18 23.88 458.18 23.88 457.18 19.46 457.18 19.46 461.11 15.53 461.11 15.53 465.04 12.6 465.04 12.6 455.71 11.6 455.71 11.6 468 23.88 468 23.88 467 12.6 467 12.6 466.04 16.53 466.04"
  })))));
};
export default SvgDSignalCoolingPumpStaged2;